import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MUIButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

const defaultProps = {
  className: null,
  classes: null,
  loading: false,
  disabled: false,
  children: null,
};

const Button = forwardRef(({ className, classes, loading, disabled, children, ...props }, ref) => {
  const styles = useStyles({ classes });

  return (
    <MUIButton
      {...props}
      ref={ref}
      className={cx(styles.root, { [styles.loading]: loading }, className)}
      disabled={disabled || loading}
    >
      <span className={styles.label}>{children}</span>
      <CircularProgress
        className={styles.spinner}
        size={24}
      />
    </MUIButton>
  );
});

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
